import { Injectable } from '@angular/core';
import {
  LytxAmplitudePropertiesBase,
  MonitoringService,
} from '@lytx/platform.ui.components';

@Injectable({
  providedIn: 'root',
})
export class MonitoringOverrideService extends MonitoringService {
  constructor() {
    super(null, null, null, null, null, null, null, null, null, null, null);
  }

  override addAmplitudePageAction(
    eventName: string,
    eventProperties: LytxAmplitudePropertiesBase,
  ): void {
    return;
  }

  override addPageAction(actionName: string, customData?: any): void {
    return;
  }
}
